define((require) => {
    "use strict";

    var Marionette            = require("marionette"),
        SalesforceCommerceProductView = require("../view/SalesforceCommerceProductView"),
        template              = require("../view/SalesforceCommerceProductView.tpl");

    /**
     * The collection view of <tt>SalesforceCommerceProductView</tt>.
     *
     * @author Pedro Augusto
     * @class SalesforceCommerceProductCollectionView
     * @constructor
     */
    return Marionette.CollectionView.extend({

        template: template,

        itemView: SalesforceCommerceProductView,

        /**
         * Add the state active for the item view that matches the <tt>productID</tt>.
         *
         * @param {String} productId
         */
        highlightSelectedProduct: function(productId) {
            // iterate over all of the views and process them
            this.children.each((view) => {
                // Set the current element as active.
                view.$el.toggleClass("active", view.model.get("productID") === productId);
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/view/SalesforceCommerceProductCollectionView.js